import { Channel } from '../tickets';
export var timePeriodTrigger = { timePeriodMinutes: null };
export var numberTrigger = { number: null };
export var priorityChangeTrigger = { toPriority: null, fromPriority: null };
export var articleTrigger = { articleType: null };
export var ticketStatusTrigger = { ticketStatus: null };
export var callStatusTrigger = { callStatuses: null };
export var callStatusGroupTrigger = { callStatusGroup: null };
export var agentStatusTrigger = {
    callCenterAgentStatuses: [],
    agentCustomStatusId: null,
};
export var customFieldTrigger = { customFieldId: null, customFieldItemType: null };
export var percentTrigger = { percent: null };
export var replyTypesTrigger = { replyTypes: null };
export var participantsTrigger = { assignedUserIds: [], assignedGroupIds: [] };
export var csatTrigger = { ratings: null, hasRatingComment: null };
export var callChannelTrigger = { channels: [Channel.PHONE_INBOUND, Channel.PHONE_CALLBACK] };
export var emptyTrigger = {};
export var isTimePeriodScenario = function (scenario) { return 'timePeriodMinutes' in scenario; };
export var isNumberScenario = function (scenario) { return 'number' in scenario; };
export var isPercentScenario = function (scenario) { return 'percent' in scenario; };
export var isReplyTypeScenario = function (scenario) { return 'replyTypes' in scenario; };
export var isPriorityScenario = function (scenario) { return 'fromPriority' in scenario && 'toPriority' in scenario; };
export var isTicketStatusScenario = function (scenario) { return 'ticketStatus' in scenario; };
export var isArticleTypeScenario = function (scenario) { return 'articleType' in scenario; };
export var isCallResultScenario = function (scenario) { return 'callStatuses' in scenario; };
export var isCustomFieldScenario = function (scenario) { return 'customFieldId' in scenario && 'customFieldItemType' in scenario; };
export var isCallStatusGroupScenario = function (scenario) {
    return 'callStatusGroup' in scenario && !isCallResultScenario(scenario);
};
export var isAgentStatusScenario = function (scenario) {
    return 'callCenterAgentStatuses' in scenario || 'agentCustomStatusId' in scenario;
};
export var isParticipantsScenario = function (scenario) {
    return 'assignedUserIds' in scenario || 'assignedGroupIds' in scenario;
};
export var isCSATScenario = function (scenario) { return 'ratings' in scenario && 'hasRatingComment' in scenario; };
export var isChannelScenario = function (scenario) { return 'channels' in scenario; };
//# sourceMappingURL=triggers.js.map